import Singleton from './Singleton'
import axios from 'axios'
import locales from '../locales.json'

const { API_TEXTS } = locales

const baseURL = (document.location.hostname === 'localhost') ? `http://portal-bandi.localhost/api/` : document.location.origin + '/api/'

export default class App extends Singleton {

  constructor() {
    super()

    this.messageApi = null

    this.api = axios.create({
      baseURL,
      withCredentials: true,
      headers: { 'Content-Type': 'application/json' },
    })

    this.api.interceptors.response.use(
      (response) => response.data,
      (error) => Promise.reject(App.normalizeError(error)),
    )

    window.$app = this
  }

  static get api() {
    return this.instance.api
  }

  static normalizeError(error) {
    if (error.code === 'ERR_CANCELED') {
      return { status: 0, exception: 'canceled', message: API_TEXTS.canceledError, detail: null }
    }

    const status = error.response?.status ?? 0

    // Bez odpovedi = vypadek site nebo zablokovane CORS.
    if (!status) {
      return { status: 0, exception: 'network_error', message: API_TEXTS.networkError, detail: error.message }
    }

    if (status >= 500) {
      return { status, exception: 'server_error', message: API_TEXTS.serverError, detail: null }
    }

    const body = error.response?.data
    const exception = body?.exception ?? 'client_error'

    return {
      status,
      exception,
      message: API_TEXTS[exception] ?? API_TEXTS.clientError,
      detail: body?.message ?? null,
    }
  }

  checkRegistrationAbility(type, value, config, recaptcha_token) {
    return this.api.post('customer/check-registration-ability', { type, value, recaptcha_token }, config)
  }

  register(payload, config, recaptcha_token) {
    return this.api.post('customer/register', { ...payload, recaptcha_token: recaptcha_token }, config)
  }

  findCustomerByEmail(email, config) {
    return this.api.get(`customer/find-by-email?email=${encodeURIComponent(email)}`, config)
  }

  getRegistrationStatus(email, config) {
    return this.api.get('customer/status', { ...config, params: { email } })
  }

  getRegistrationStatusById(customerId, config) {
    return this.api.get('customer/status', { ...config, params: { customer_id: customerId } })
  }

  // zakaznika dohleda backend podle emailu, typ udalosti zna z konfigurace
  sendCardEvent(email, config, recaptcha_token) {
    return this.api.post('customer/send-card-event', { email, recaptcha_token }, config)
  }

  sendDoubleOptInEvent(email, config, recaptcha_token) {
    return this.api.post('customer/send-double-opt-in-event', { email, recaptcha_token }, config)
  }

  sendAccountConfirmation(customerId, config, recaptcha_token) {
    return this.api.post('customer/send-account-confirmation', { customer_id: customerId, recaptcha_token }, config)
  }

  setMessageApi(messageApi) {
    this.messageApi = messageApi
  }

  static $toast(content, type = 'success') {
    this.instance.messageApi?.open({ type, content })
  }

  static $e(content) {
    this.$toast(content, 'error')
  }


  static isDevelopment() {
    return (document.location.hostname === 'localhost')
  }
}

export const $app = App.instance
